import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const NoPage = () => {

  return (
 
      <Container component='main'>
        <Box
          sx={{
            width: '100%',
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >

          <Typography variant='h4'>
            404 | Página não encontrada...
          </Typography>

          <Link to='/'>
            <Typography>
              Voltar
            </Typography>
          </Link>
          
        </Box>
      </Container>

  );
};

export default NoPage;